module.exports = __webpack_public_path__ + "img/no.6ad53928.svg";